module.exports = __webpack_public_path__ + "img/presentation10.e1576da0.jpg";